<template>
  <div
    class="contract-documents-table">
    <template v-if="items && items.length">
      <div
        v-for="(contract, contractIndex) in items"
        :key="contract.fileId+'_'+contractIndex"
        class="contract-documents-table__row">
        <div>
          <div class="contract-documents-table__info">
            <div class="contract-documents-table__title">
              <div
                class="flex">
                <sIcon
                  class="mr-3 my-auto"
                  :size="18"
                  type="draft"/>
                <div
                  class="my-auto"
                  data-qa="file-name">
                  <div>{{ contract.name }}</div>
                </div>
              </div>
            </div>
            <div class="contract-documents-table__status">
              <StatusChip
                :color="$t('Tenders.ContractStatus.' + contract.status+'.color')"
                data-qa="file-status"
                :name="$t('Tenders.ContractStatus.' + contract.status+'.label')"/>
            </div>
          </div>
          <div class="contract-documents-table__dopinfo">
            <div
              v-if="contract.documentNumber"
              class="width-100">
              {{ $t('Tenders.Number') }}: {{ contract.documentNumber || '-' }}
            </div>
            <div
              v-if="contract.documentDate"
              class="width-100">
              {{ $t('Tenders.Date1') }}: {{ $d(new Date(contract.documentDate)) }}
            </div>
          </div>
        </div>
        <sButton
          v-if="contract.link"
          data-qa="btn-download-file"
          icon="download"
          :loading="loadFile[contract.fileId]"
          small
          type="text"
          @click="getContractFile(contract)"/>
      </div>
    </template>
    <span v-else>–</span>
  </div>
</template>
<script>
import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()
import StatusChip from 'components/common/elements/StatusChip.vue'

export default {
  name: 'contractDocuments',
  data() {
    return {
      loadFile: {}
    }
  },
  methods: {
    getContractFile(file) {
      this.$set(this.loadFile, file.fileId, true)
      files_api.getSignyDocuments(file.fileId)
        .then((response) => {
          let url = URL.createObjectURL(response.data)
          let a = document.createElement('a')
          a.setAttribute('href', url)
          a.setAttribute('download', file.name)
          a.click()
        })
        .catch(() => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Common.errorLoadingData'),
            duration: 10,
          })
        })
        .finally(() => {
          this.loadFile[file.fileId] = false
        })
    },
  },
  props: {
    items: {
      type: Array
    }
  },
  components: {
    StatusChip,
  },
}
</script>
<style scoped lang="scss">
.contract-documents-table {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: start;
  width: 100%;
  &__row {
    display: grid;
    grid-template-columns: minmax(205px, 1fr) 30px;
    text-align: left;
    margin-top: 5px;
    border-bottom: thin solid var(--color-main-green);
  }
  &__info {
    display: flex;
    justify-content: space-between;
  }
  &__title {
    width: 180px;
  }
  &__status {
    width: 90px;
    margin-left: 10px;
  }
  &__dopinfo {
    display: flex;
    flex-wrap: wrap;
    opacity: 0.5;
    font-size: 0.75rem;
    div {
      min-width: 115px;
    }
  }
}
</style>
